"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "IPAddressModel", {
    enumerable: true,
    get: function() {
        return IPAddressModel;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const IPAddressModel = _zod.z.object({
    _id: _zod.z.instanceof(_bson.ObjectId),
    company: _zod.z.instanceof(_bson.ObjectId),
    created_by: _zod.z.instanceof(_bson.ObjectId),
    deleted: _zod.z.boolean().optional(),
    deleted_at: _zod.z.date().optional(),
    description: _zod.z.string(),
    history: _zod.z.array(_zod.z.object({
        description: _zod.z.string(),
        raw_ip_input: _zod.z.string(),
        updated_at: _zod.z.date(),
        updated_by: _zod.z.instanceof(_bson.ObjectId)
    })).optional(),
    ip_network: _zod.z.string(),
    label: _zod.z.string().optional(),
    max_ip_address: _zod.z.string(),
    min_ip_address: _zod.z.string(),
    raw_ip_input: _zod.z.string()
});
